import CardSystem from '../CardSystem';
import CardAnimationTask from '../../../Utility/Task/CardAnimationTask';
import { ICardStateTaskData } from '../../../State/Card/ICardState';
import CardComponent from '../../../Component/Level/Card';

export default function WiggleCardAnimation(
    system: CardSystem,
    taskData: ICardStateTaskData
): void {
    const card = system.getCardByID(taskData.cards[0]);

    if (card.getComponent(CardComponent).flipping) return;

    system.taskQueue.queue(
        new CardAnimationTask(taskData, system, 'CardWiggle', card, null, true)
    );
}
